import store from '@services/Store'
import { isValidToken, isForgottenPassword } from './actions'
import history from '@services/History'
import { clearStore } from '../../index.Dux'
import { clearServices } from '../../utilities/actions'
import Axios from 'axios'

export const refreshTokenInterceptor = async (request) => {
  try {
    let jwt = store.getState() && store.getState().auth && store.getState().auth.jwtToken
    if (!isValidToken(jwt)) {
      // when isForgottenPassword we dont need to check if jwt is valid
      if (isForgottenPassword(request.url)) {
        return request
      }
      // clean services and redirect to our login
      clearServices()
      store.dispatch(clearStore())
      console.log(request)
      history.push('/')

      // es invalido y no vacío
      if (jwt) throw new Axios.Cancel('Operation canceled by the user.')
    }
    // if no error, continue executing
    return request
  } catch (e) {
    console.log('>>>>>>>>', e)
  }
}
